<div class="d-flex flex-row blog-container justify-content-start align-items-start">
  <div *ngIf="blogCategoryId && !currentBlogCategory" class="flex-100 text-center">
    <div class="h5">Loading ...</div>
  </div>
  <div class="flex-100" *ngIf="!showSearchResults">
    <div class="d-flex flex-row flex-wrap justify-content-start align-items-start">
      <div class="flex-100 ">
        <h1>{{currentBlogCategory?.name}}</h1>
      </div>
      <div class="flex-100 d-flex flex-row flex-wrap post-list">
        <div [@fadeInUp] *ngFor="let post of currentBlogCategory?.posts; let i = index;" class="flex-100 flex-md-50">
          <div class=" blog-post-card">
            <a [routerLink]="[post.routerLink]" class="title">
              <picture>
                <source [attr.defaultImage]="settings?.holdingImage?.small" [attr.lazyLoad]="post.pictureUrl + '.webp'" type="image/webp" />
                <img [defaultImage]="settings?.holdingImage?.small" [lazyLoad]="post.pictureUrl" [alt]="post.title" />
              </picture>
              <div class="title-overlay">
                <span class="post-title">> {{post.title}}</span>
                <span *ngIf="post.bodyOverview" class="post-overview">{{post.bodyOverview}}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-100 flex-lg-80" *ngIf="showSearchResults">
    <div class="flex-100 d-flex flex-row flex-wrap post-list">
      <div class="flex-100 mt-2 ml-2">
        <button mat-raised-button (click)="showSearchResults=false">
          <mat-icon>chevron_left</mat-icon>Back to Topics
        </button>
      </div>
      <div class="flex-100">
        <h1>Search Results</h1>
      </div>
      <div [@fadeInUp] *ngFor="let post of searchedPosts; let i = index;" class="flex-100 flex-md-50">
        <div class=" blog-post-card">
          <a [routerLink]="[post.routerLink]" class="title">
            <picture>
              <source [attr.defaultImage]="settings?.holdingImage?.small" [attr.lazyLoad]="post.pictureUrl + '.webp'" type="image/webp" />
              <img [defaultImage]="settings?.holdingImage?.small" [lazyLoad]="post.pictureUrl" [alt]="post.title" />
            </picture>
            <div class="title-overlay">
              <span class="post-title">> {{post.title}}</span>
              <span *ngIf="post.bodyOverview" class="post-overview">{{post.bodyOverview}}</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
